(function (Drupal) {
  Drupal.behaviors.footer = {
    attach: function (context, settings) {
      const deviceDetect = {
        breakpointMobile: 768,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointMobile}px)`).matches;
        },
      };

      if (deviceDetect.isMobile()) {
        const accordions = document.querySelectorAll('.site-footer__top .block-menu', context);

        accordions.forEach(accordion => {
          const accordionHeader = accordion.querySelector('h2');

          if (accordionHeader) {
            accordionHeader.addEventListener('click', function() {
              // Remover la clase 'active' de todos los otros acordeones
              accordions.forEach(otherAccordion => {
                if (otherAccordion !== accordion) {
                  otherAccordion.classList.remove('active');
                }
              });

              // Alternar la clase 'active' en el acordeón clicado
              accordion.classList.toggle('active');
            });
          }
        });
      }
    }
  };
})(Drupal);
